module.exports = __webpack_public_path__ + "fonts/CrimsonText-BoldItalic.6be08070.eot";